import { Component, Shark, Utils } from "shark-mvc";
import { folderManager } from "../managers/folderManager.js";

// import templateContent from "../../_shark_templates/components/breadcrumb.html";

class FolderManagementComponent extends Component {
	constructor () {
		super("folderManagementComponent");
		// this.addTemplate("", templateContent);
	}





	
	deleteFolderBtn_clickHandler (event, data) {
		if (confirm("Sei sicuro di voler cancellare questa cartella?\n\nSe procedi anche il suo contenuto verrà cancellato!")) {
			const selectedFolder = Utils.safp(Shark.get("folderList"), "guid", data.guid);
			console.log({ selectedFolder, data });
			folderManager.delete(selectedFolder);
		}
		// const subFolders = [];
		// const folderBreadCrumb = Shark.get("documentsFolderBreadCrumb");
		// const currentFolder = folderBreadCrumb[folderBreadCrumb.length - 1].name;
		// console.log({folderBreadCrumb});

		// this.set({
		// 	currentFolder,
		// 	folderBreadCrumb,
		// 	breadcrumbActive: this.get("isActive"),
		// 	subFolders,
		// });
	}


	editFolderBtn_clickHandler (event, data) {
		const itemClassList = document.querySelector("#newFolderTray").classList;
		const selectedFolder = Utils.safp(Shark.get("folderList"), "guid", data.guid);

		if (selectedFolder) {
			itemClassList.add("show");
			document.querySelector("#newFolderNameField").value = selectedFolder.name;
			document.querySelector("#newFolderNameField").focus();
			
			Shark.set("editingFolder", selectedFolder);
		}
		
		console.log({ selectedFolder, data });
	}

	init () {
		// this.set("isActive", false);
	}

}

const folderManagementComponent = new FolderManagementComponent();

Shark.registerComponent(folderManagementComponent);

export { folderManagementComponent };
